export enum ThemeType {
  light = "light",
  dark = "dark",
}
